import React, { useState } from "react";
import { ArrowForwardIos, ArrowForward } from '@mui/icons-material/';


// BtnBorder: Componenete que renderiza un botón con la palabra "Ingresar" y una flecha hacia la derecha.

const BtnBorder = () => {
    const [hovered, setHovered] = useState(false); //Estado para actualizar el hover sobre el botón

    const handleHoverEnter = () => { //Función para manejar cuándo entra o sale el mouse del botón.
        setHovered(true);
    };
    const handleHoverLeave = () => { //Función para manejar cuándo entra o sale el mouse del botón.
        setHovered(false);
    };

    return (
        <div className="container--btn-border">
            <button 
                type="submit" 
                className="btn-border" 
                onMouseEnter={handleHoverEnter} 
                onMouseLeave={handleHoverLeave}
            >
                Ingresar {hovered ? <ArrowForward sx={{marginLeft: "10px"}} /> : <ArrowForwardIos sx={{marginLeft: "10px"}}/>}
            </button>
        </div>
    );
};

export default BtnBorder;
